import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-pagination__list {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n.vai-pagination__list-item {\n  display: inline-block;\n  list-style-type: none;\n  margin: 0 4px 0 0;\n  height: 32px;\n}\n.vai-pagination__list-item:last-of-type {\n  margin: 0;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
